import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { Project } from '../../types/Project'

interface Props {
  project: Project
  handleClose: () => void
}

export const Actief = ({ handleClose, project }: Props) => {
  const { mutate: saveEvent } = useSaveEvent()

  const handleClickJa = () => {
    saveEvent(
      {
        id: project.aanvraagID,
        type: 'actief',
        source: 'manual',
        data: {
          isActive: !project.isActive,
        },
      },
      {
        onSuccess: () => {
          handleClose()
        },
      },
    )
  }

  return (
    <>
      <DialogTitle>
        {project.isActive ? 'Deactiveren' : 'Activeren'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Wilt u project ${project.aanvraagID} ${
            project.isActive ? 'inactief' : 'actief'
          } maken?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClickJa()} color="primary">
          Ja
        </Button>
        <Button onClick={handleClose} color="primary" autoFocus>
          Nee
        </Button>
      </DialogActions>
    </>
  )
}
